// eslint-disable-next-line no-restricted-imports
import { Button } from '@mantine/core';
import { Icon } from '@repo/foundations';
import { useCallback } from 'react';
import { useLineageFlowContext } from '../../context/LineageFlowProvider/LineageFlowContext';
import { useStyles } from './FetchLineageButton.styles';
import type { FetchLineageButtonProps } from './FetchLineageButton.types';

function FetchLineageButton({
	id,
	direction,
	count,
	visible,
}: FetchLineageButtonProps) {
	const { classes } = useStyles({ direction });

	const { onFetchLineage } = useLineageFlowContext();

	const handleFetchLineage = useCallback(() => {
		if (!direction) {
			return;
		}

		onFetchLineage({ id, direction });
	}, [onFetchLineage, id, direction]);

	if (!visible) {
		return null;
	}

	const iconName = direction === 'UPSTREAM' ? 'arrowLeft' : 'arrowRight';

	return (
		<Button
			classNames={classes}
			rightIcon={<Icon name={iconName} />}
			onClick={handleFetchLineage}
		>
			{count}
		</Button>
	);
}

export default FetchLineageButton;
